import React, { useEffect, useState } from "react";
import { Container, Table } from "reactstrap";
import {
  keyAverage,
  keyHeader,
  keyTotal,
  microgridHeaders,
  yakubaHeaders,
  hironoHeaders,
  highlightLabels,
  highlightDatas,
  noDecimal,
  alwaysHighlightNames,
} from "./headers";

export default function DemandTable({ datasetType = "microgrid", jsonData }) {
  const [rows, setRows] = useState([]);
  const [labelsList, setLabelsList] = useState([]);

  const headers =
    datasetType === "microgrid"
      ? microgridHeaders
      : datasetType === "hirono"
        ? hironoHeaders
        : yakubaHeaders;

  const formatToOneDecimal = (num) => {
    if (num === null || num === undefined || num === "") return "-";
    if (Number(num) === 0) return 0;
    return Number(num).toFixed(1);
  };

  useEffect(() => {
    let maxLength = 0;
    Object.keys(headers).forEach((key) => {
      if (jsonData?.[key]?.length > maxLength) {
        maxLength = jsonData[key].length;
      }
    });
    if (maxLength === 0) maxLength = 48;

    const computedRows = Object.keys(headers).map((key) => {
      let values = jsonData?.[key] || [];

      // If the header label is "-", force all values to be empty so they render as "-"
      if (headers[key] === "-") {
        values = [];
      }

      if (values.length < maxLength) {
        const padded = new Array(maxLength).fill("");
        for (let i = 0; i < values.length; i++) {
          padded[i] = values[i];
        }
        values = padded;
      }

      let totalOrAverage = "-";

      if (keyAverage.includes(key)) {
        const numericValues = values.filter((v) => !isNaN(parseFloat(v)));
        if (numericValues.length > 0) {
          totalOrAverage = (
            numericValues.reduce((sum, val) => sum + parseFloat(val), 0) /
            numericValues.length
          ).toFixed(1);
        }
      } else if (keyTotal.includes(key)) {
        const numericValues = values.filter((v) => !isNaN(parseFloat(v)));
        if (numericValues.length > 0) {
          totalOrAverage = numericValues
            .reduce((sum, val) => sum + parseFloat(val), 0)
            .toFixed(1);
        }
      } else if (keyHeader.includes(key)) {
        totalOrAverage = "合計 / 平均";
      }

      return { key, label: headers[key], totalOrAverage, values };
    });

    setRows(computedRows);
    setLabelsList(computedRows.map((row) => row.label));
  }, [jsonData, datasetType]);

  return (
    <Container
      fluid
      className={`px-5 mt-2 ${datasetType === "hirono" ? "hirono-layout" : ""}`}
    >
      <div className="table-layout d-flex">
        <div className="d-flex">
          <div className="table-head ">
            <ul>
              {labelsList.map((label, idx) => (
                <li
                  key={idx}
                  className={highlightLabels.includes(label) ? "bg2" : ""}
                >
                  {label}
                </li>
              ))}
            </ul>
          </div>
          <div className=" table-head table-1">
            <ul>
              {rows.map((row) => {
                const isHighlighted = alwaysHighlightNames.includes(row.key);

                return (
                  <li key={row.key} className={isHighlighted ? "bg2" : ""}>
                    {row.totalOrAverage}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <Table bordered responsive>
          <tbody>
            {rows.map((row) => (
              <tr key={row.key} className="table-row">
                {row.values.map((val, idx) => (
                  <td
                    className={`table-data ${row.key === "id" ? "bg" : ""} 
                 ${highlightDatas.includes(row.key) ? "table-data1" : ""}
                  `}
                    key={row.key + idx}
                  >
                    {noDecimal.includes(row.key)
                      ? val === null || val === undefined || val === ""
                        ? "-"
                        : val
                      : formatToOneDecimal(val)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
}
